export default __webpack_public_path__ + "files/bc39a70bb1048e5a929335dd8e40d958.apng";